<div style="background-color: #F5F7F8; height: 100vh; overflow-y: scroll; padding: 7px; overflow-x: hidden;">
    <img style="width: 22px; height: 22px; position: relative; top: 30px; left: 15px;" (click)="this.back()" src="/assets/images/shared/back.svg">
    <h2 style="text-align: center; margin-top: 3px;">Категории</h2>
    <div class="row justify-content-around" style="margin-left: 5px; margin-right: 5px;">
        <div class="col-6" style="padding: 3px;" *ngFor="let category of this.categories; index as i" (click)="this.goToSub(category)">
            <div class="card" style="height: 180px; margin-bottom: 10px;  margin-left: 5px;  margin-right: 5px; border-radius: 10px; border: unset;">
                <img [src]="this.getCategoryImageById(i+1)" style="height: 130px;" class="card-img-top img-fluid" alt="...">
                <div class="card-body" style="padding: 0px;">
                  <p style="text-align: center; font-weight: 600; font-size: 0.8em; width: 90%; margin: auto;" class="card-text">{{category.name}}</p>
                </div>
              </div>
        </div>
    </div>
</div>